"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardTimeoutAlert = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
// INTERNAL BITS
const bid_data_service_1 = require("./bid-data.service");
const branding_service_1 = require("./branding.service");
let DashboardTimeoutAlert = class DashboardTimeoutAlert {
    constructor(_bidData, _branding) {
        this._bidData = _bidData;
        this._branding = _branding;
        this.showExportDataEmail = false;
        this.onExportError = () => { };
    }
};
exports.DashboardTimeoutAlert = DashboardTimeoutAlert;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], DashboardTimeoutAlert.prototype, "events", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], DashboardTimeoutAlert.prototype, "dataSource", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Function)
], DashboardTimeoutAlert.prototype, "sortOrder", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], DashboardTimeoutAlert.prototype, "sortByKey", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], DashboardTimeoutAlert.prototype, "cumulativeView", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], DashboardTimeoutAlert.prototype, "onExportError", void 0);
exports.DashboardTimeoutAlert = DashboardTimeoutAlert = __decorate([
    (0, core_1.Component)({
        selector: 'dashboard-timeout-alert',
        template: `<div class="fullPageOverlay" *ngIf="_bidData.showQueryErrorAlert">
  <div class="modalContainer">
    <div class="header">
      <h1>{{_branding.getProductName() || 'Data Alert'}}</h1>
      <div class="closeModal">
        <i (click)="_bidData.showQueryErrorAlert=false" class="fa fa-close close"></i>
      </div>
    </div>
    <div class="content">
      <div *ngIf="_bidData.showQueryTimeoutAlertMsg">
        <h2 class="h1 sectionTitle">Data Query has Timed Out</h2>
      </div>
      <div *ngIf="_bidData.showCountsAlertMsg">
        <h2 class="h1 sectionTitle">Data exceeds the allowed limit</h2>
      </div>
      <h4 class="sectionSubTitle">Please click to have the data file emailed or modify the current filters.</h4>
      <div>
        <button class="btn btn-default brtBlueBack" (click)="showExportDataEmail=!showExportDataEmail">Email As Report</button>
        <span>or</span>
        <button class="btn btn-default" (click)="_bidData.showQueryErrorAlert=false">Modify Filters</button>
      </div>
    </div>
    <div class="text-center" *ngIf="showExportDataEmail">
        <div><hr></div>
        <h5>Select the file type to be emailed and click submit request.</h5>
        <dashboard-export
          [events]="events"
          [title]="'Select Export File Type'"
          [submitBtnText]="'Submit Request'"
          [showFileSelection]="true"
          [dataSource]="dataSource.slug"
          [sortOrder]="sortOrder()"
          [sortByKey]="sortByKey"
          [cumulativeView]="cumulativeView"
          [emailData]="true"
          [rowsLimit]="50000"
          (onExportClose)="_bidData.showQueryErrorAlert=$event;"
          (onExportError)="onExportError($event)"
          >
        </dashboard-export>
      </div>
  </div>
</div>`
    }),
    __metadata("design:paramtypes", [bid_data_service_1.BidDataService,
        branding_service_1.BrandingService])
], DashboardTimeoutAlert);
//# sourceMappingURL=dashboard-timeout-alert.component.js.map